import React from 'react';
import './DirectionArrow.scss';
import { Arrow } from './constants';

const DirectionArrow = (props) => {

    const getRotationValue = (direction) => {
        switch (direction) {
            case "up":
                return "-90deg";
            case "down":
                return "90deg";
            case "left":
                return "180deg";
            case "right":
                return "0deg"
        }
    }

    return (
        <div className="direction-question">
            {[1, 2, 3].map(_ => (
                <p style={{
                    color: props.specs.arrowColors,
                    transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})`
                }}>
                    <Arrow
                        fill={props.specs.arrowColors}
                    />
                </p>
            ))}
        </div>
    );
}

export default DirectionArrow;
// {
//     type: levelNames.TRIPLE_ARROWS,
//     specs: {
//         arrowColors: colors.red,
//         arrowDirection: 'left',
//         arrowColors: colors.red,
//         answer: 2,
//         options: [
//             {
//                 name: "NO, RIGHT",
//                 value: 0,
//             },
//             {
//                 name: "YES, UP",
//                 value: 1,
//             },
//             {
//                 name: "YES, RIGHT",
//                 value: 2,
//             }
//         ]
//     }
// }